import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"
import { disableBodyScroll } from "body-scroll-lock"

app.register(
  "details",
  class extends Controller {
    static targets = ["dialog"]

    close() {
      this.open = false
      this.enableBodyScroll()
    }

    toggleBodyScroll() {
      if (this.open) {
        this.disableBodyScroll()
      } else {
        this.enableBodyScroll()
      }
    }

    enableBodyScroll() {
      if (!this.hasdDialogTarget) return
      disableBodyScroll(this.dialogTarget)
    }

    disableBodyScroll() {
      if (!this.hasDialogTarget) return
      disableBodyScroll(this.dialogTarget)
    }

    set open(value) {
      this.element.open = value
    }

    get open() {
      return this.element.open
    }
  },
)
